const getApplicationConfigMutation = (version, params) =>
    `mutation ApplicationConfigMutation {
        postApplicationConfig_${version}(${params.join(', ')}) {
            pdfAvailability_bk
        }
    }`;

export default getApplicationConfigMutation;
